import { Box } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';
import { getDefaultAnalyticsSettings } from 'core/utils/analyticsUtils';
import { useEffect, useState } from 'react';
import { analyticsService } from 'services/analyticsService';
import { formatNumber, getDateLabel } from '../utils';
import ChartCard from './ChartCard';
import ChartSettingsDialog from './ChartSettingsDialog';
import type { ChartSettings } from 'models/analytics/chartSettings';
import type { OrdersAnalytic } from 'models/analytics/orderAnalytic';
import type { FC } from 'react';

const OrdersChart: FC = () => {
  const [data, setData] = useState<OrdersAnalytic[] | null>(null);
  const [settings, setSettings] = useState<ChartSettings>(
    getDefaultAnalyticsSettings().orders
  );
  const [settingsDialogOpen, setSettingsDialogOpen] = useState(false);

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const orders = await analyticsService.getOrdersAnalytic({
        from: settings.dateRange.from,
        to: settings.dateRange.to,
        groupBy: settings.groupBy,
      });
      setData(orders);
    };
    void fetchData();
  }, [settings]);

  const handleSettingsSave = (newSettings: ChartSettings): void => {
    setSettings(newSettings);
    setSettingsDialogOpen(false);
  };

  if (!data) return null;

  return (
    <ChartCard
      title='Динамика заказов'
      onSettingsClick={() => {
        setSettingsDialogOpen(true);
      }}>
      <Box height={400}>
        <BarChart
          series={[
            {
              data: data.map((item) => item.requestsCount),
              label: 'Заявки',
              valueFormatter: (value) => formatNumber(value ?? 0),
              color: '#00BCD4',
            },
            {
              data: data.map((item) => item.ordersCount),
              label: 'Заказы',
              valueFormatter: (value) => formatNumber(value ?? 0),
              color: '#7C4DFF',
            },
          ]}
          xAxis={[
            {
              data: data.map((item) => getDateLabel(item.date, settings.groupBy)),
              scaleType: 'band',
            },
          ]}
          yAxis={[{ tickMinStep: 1 }]}
          slotProps={{
            legend: {
              direction: 'row',
              position: { vertical: 'top', horizontal: 'right' },
              padding: 0,
            },
          }}
          sx={{
            '.MuiBarElement-root': {
              rx: '5px',
            },
          }}
        />
      </Box>
      <ChartSettingsDialog
        open={settingsDialogOpen}
        settings={settings}
        onClose={() => {
          setSettingsDialogOpen(false);
        }}
        onSave={handleSettingsSave}
        title='Настройка графика "Динамики заказов"'
      />
    </ChartCard>
  );
};

export default OrdersChart;
